module.exports = __webpack_public_path__ + "img/2025-07-21c_1.b3c359d3.jpg";